import AclDetails from './AclDetails';

export default AclDetails;
